import Mastercard from './logos/mastercard.svg';
import Visa from './logos/visa.svg';
import Webmoney from './logos/wm.svg';

const WithdrawalMethods: React.FC = () => {
    return (
        <div className="flex flex-wrap justify-center gap-[32px] sm:justify-start">
            <img
                src={Mastercard}
                key="mastercard"
                alt="mastercard logo"
                loading="lazy"
                className="h-[20px]"
            />
            <img src={Visa} key="Visa" alt="Visa logo" loading="lazy" className="h-[20px]" />
            <img
                src={Webmoney}
                key="Webmoney wallet"
                alt="Webmoney logo"
                loading="lazy"
                className="h-[20px]"
            />
        </div>
    );
};

export default WithdrawalMethods;
